/**
 * Utility for working with URL GET parameters
 */

export interface DesignParams {
    background?: string;
    cardBack?: string;
    cardFront?: string;
}

/**
 * Get design-related parameters from URL query string
 */
export function getDesignParamsFromURL(): DesignParams {
    const params = new URLSearchParams(window.location.search);
    
    const result: DesignParams = {};
    
    // Check for background parameter
    const background = params.get('background');
    if (background) {
        result.background = background;
    }
    
    // Check for card back parameter (support both camelCase and snake_case)
    const cardBack = params.get('cardBack') || params.get('card_back');
    if (cardBack) {
        result.cardBack = cardBack;
    }
    
    // Check for card front parameter (support both camelCase and snake_case)
    const cardFront = params.get('cardFront') || params.get('card_front');
    if (cardFront) {
        result.cardFront = cardFront;
    }
    
    return result;
}

/**
 * Check if URL has any design parameters
 */
export function hasDesignParams(): boolean {
    const params = getDesignParamsFromURL();
    return !!(params.background || params.cardBack || params.cardFront);
}

/**
 * Remove design parameters from URL without page reload
 */
export function removeDesignParamsFromURL(): void {
    const url = new URL(window.location.href);
    const params = url.searchParams;
    
    // Remove all design-related parameters
    params.delete('background');
    params.delete('cardBack');
    params.delete('card_back');
    params.delete('cardFront');
    params.delete('card_front');
    
    // Update URL without reloading the page
    const newUrl = params.toString() ? `${url.pathname}?${params.toString()}` : url.pathname;
    window.history.replaceState({}, '', newUrl);
}

